import router from "@/router";
import { getLoginToken, iframePost, isInIframe } from "@/utils";
import { isApp } from "@/utils/device";
import { tokenExpires } from "@/utils/starnest";
import axios from "axios";
import { showToast } from "vant";

const initAxios = axios.create({
  timeout: 1800000//数据响应过期时间
})

//请求拦截器
initAxios.interceptors.request.use(async(config) => {
      // const account = sessionStorage.get('account', {});
      // const chainId = sessionStorage.get('chainId');

      // if (chainId && account?.name) {
      //   config.headers['x-viewer-wallet-address'] = account?.name;
      //   config.headers['x-viewer-chain-id'] = chainId;
      // }

      // config.headers['tenant-id'] = 1;

      // let loginToken:any = getLoginToken();
      // const t = +new Date();
      // if (loginToken && loginToken.expiresTime) {
      //   try {
      //     // h5中token过期，提前10秒刷新
      //     if (t >= loginToken.expiresTime - 10000) {
      //       const {
      //         data: { data },
      //       } = await axios.get(api.refreshToken + '?refreshToken=' + loginToken.refreshToken, {
      //         headers: {
      //           Authorization: `Bearer ${loginToken.accessToken}`,
      //           'tenant-id': 1,
      //         },
      //       });
      //       if (data) {
      //         data['account'] = loginToken.account;
      //         sessionStorage.set('token', data);
      //         loginToken = data;
      //       }
      //       // 理论上不需要更新modal里token。modal里的token只用了account。
      //     }
      //   } catch (e: any) {
      //     throw `refresh Token error: ${e.message}`;
      //   }
      // }

      // if (loginToken && !notRequiredAuthorizationApis.includes(config.url)) {
      //   config.headers['Authorization'] = `Bearer ${loginToken.accessToken}`;
      //   return config;
      // }

      // // amaxscan域名下接口附加headers会报跨域问题
      // if (config.url.startsWith(import.meta.env.)) {
      //   config.headers = undefined;
      // }

      // return config;
  if (config.url?.includes('v1/chain')) {
    return config
  }
  //在发送之前做点什么
  // config.headers['Authorization'] = `Bearer 976005c81d964199b508851646b6d9f2`
  // config.headers['Authorization'] = `Bearer a6f97370a626426aaf1c282ea6594be4`
  console.log((window as any).APLINK_STARNEST,'(window as any).APLINK_STARNEST');
  if ((window as any).APLINK_STARNEST && (window as any).APLINK_STARNEST.token) {
    console.log((window as any).APLINK_STARNEST.token,'token / APP访问');
    sessionStorage.setItem('APLINK_STARNEST_TOKEN',(window as any).APLINK_STARNEST.token)
    config.headers['Authorization'] = `Bearer ${(window as any).APLINK_STARNEST.token}`;
  }else{
    console.log((window as any).APLINK_STARNEST,'no token / h5访问');
    if (localStorage.getItem('APLINK_STARNEST_TOKEN') || sessionStorage.getItem('APLINK_STARNEST_TOKEN')) {
      config.headers['Authorization'] = `Bearer ${sessionStorage.getItem('APLINK_STARNEST_TOKEN')}`;
    }
  }
  config.headers['tenant-id'] = 1;
  console.log(config,'config');
  
  return config
}, (error) => {
  //对请求错误做点什么
  return error
})
function _tokenExpires() {
  if (isApp) {
    console.log('App环境 刷新token');
    // showToastContent('token过期，刷新token');
    tokenExpires();
  }else{

  }
}

//响应拦截器
initAxios.interceptors.response.use((response) => {
  if (response.data.code) {
    const data = response.data
    console.log(data,'response.data');
    
    if ([200, 0].includes(data.code)) {
      // 正常请求返回
    } else if (data.code === 401) {
      _tokenExpires();
      if (isInIframe()) {
        console.log('iframe 环境');
        iframePost('needlogin')
      }
    } else if (data.code === 4011) {
    } else if (data.code === 1042) {
      showToast('accountPasswordError');
    } else {
      // const code = data.code.toString();
      showToast(data.msg);
    }
  }
  return response.data

  // if (response.status === 200 ) {

  //   if (response.data.code === 401) {
  //     // tokenExpires()
  //     if (isInIframe()) {
  //       iframePost('needlogin')
  //     }else{
  //       router.push('/login')
  //     }
  //   }
    
  //   return response.data
  // } else {
  //   return {resultCode: -1}
  // }
},
(error) => {
  if (axios.isCancel(error)) {
    return new Promise(() => {});
  }
  const { data } = error.response || {};

  if (data.code === 401) {
    _tokenExpires();
  }
  if (data) {
    // 为了不被阻断
    return Promise.resolve(data);
  }
  return Promise.reject(error);
}
)
//导出
export default () => initAxios